export default __webpack_public_path__ + "static/media/zoom_fit.35660b19.svg";